// src/pages/pharmacy/DeliveryManagement.js
import React from 'react';
import { Truck } from 'lucide-react';

const DeliveryManagement = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Delivery Management</h1>
        <p className="text-gray-600 mt-1">Track and manage delivery orders</p>
      </div>

      <div className="bg-white rounded-lg shadow-md p-12 text-center">
        <Truck className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-gray-900 mb-2">No Active Deliveries</h3>
        <p className="text-gray-600">
          Orders out for delivery will appear here
        </p>
      </div>
    </div>
  );
};

export default DeliveryManagement;